module.exports = __webpack_public_path__ + "img/ordinal.64f34120.svg";